var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FC5466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.933 9.849l.294-6.802H6.772l.294 6.802h1.867zm-.95 3.274c.364 0 .668-.108.912-.325.244-.216.366-.493.366-.83 0-.337-.122-.614-.366-.83-.244-.217-.548-.325-.913-.325-.364 0-.668.108-.912.324a1.062 1.062 0 00-.366.83c0 .338.122.615.366.831.244.217.548.325.912.325z"
  }))));
}

export default __webpack_public_path__ + "fc5e3ac51d2dcd23a6ebf7d3761cce56.svg";
export { SvgErrorCircle as ReactComponent };